import moment from "moment";

const dateFormat = "YYYY-MM-DD";
const momentDate = (value) => {
  const date = moment(value);
  return date.isValid() ? date : moment();
};

export const odata = {
  contains: (columnName, value) => {
    value = value.replaceAll("'", '"');
    return `contains(tolower(${columnName}), tolower('${value}'))`;
  },
  notContains: (columnName, value) => {
    value = value.replaceAll("'", '"');
    return `not contains(tolower(${columnName}), tolower('${value}'))`;
  },
  dateRange: (columnName, startDate, endDate) => {
    const formatedStartDate = momentDate(startDate).format(dateFormat);
    const formatedEndDate = momentDate(endDate)
      .add(1, "days")
      .format(dateFormat);

    return `date(${columnName}) ge ${formatedStartDate} and date(${columnName}) lt ${formatedEndDate}`;
  },
  dateRangeWithMinute: (columnName, startDate, endDate) => {
    var startDateFilter = moment(startDate).add(-3,"hours").format('YYYY-MM-DDTHH:mm:00+03:00').replace("+03:00","")
    var endDateFilter = moment(endDate).add(-3,"hours").format('YYYY-MM-DDTHH:mm:00+03:00').replace("+03:00","")
    endDateFilter += "Z";
    startDateFilter += "Z";
    const formatedStartDate = startDateFilter;
    const formatedEndDate = endDateFilter;

    return `date(${columnName}) ge ${formatedStartDate} and date(${columnName}) lt ${formatedEndDate}`;
  },
  ConditionalRange: (columnName, minValue, maxValue) => {
    const conditions = [];

    if (minValue || minValue === 0) {
      conditions.push(`${columnName} Ge ${minValue}`);
    }

    if (maxValue || maxValue === 0) {
      conditions.push(`${columnName} Le ${maxValue}`);
    }

    return conditions.join(" and ");
  },
  orderBy: (columnName) => {
    return `$orderby=${columnName} asc`;
  },
  orderByDesc: (columnName, value) => {
    return `$orderby=${columnName} desc`;
  },
};
